// Deterministic, team-NEUTRAL identity colour per player, so the same person
// always reads in the same colour across the chat, the suspicion tally, the vote
// list and @-mentions. Derived from the public player id (a hash → palette
// index), so it's stable across sessions and needs no server state.
//
// ⚠️ It must never hint at a role/team — this is identity, not allegiance. So the
// palette deliberately avoids the team-signal colours (gold = eerlijken, red =
// shapeshifters). Tints are used on the name + a border/avatar wash, not a loud
// full fill, so text stays readable on the dusk background.

// ~14 dusk-readable, reasonably colourblind-distinct hues (no gold, no red).
const PALETTE: readonly string[] = [
  '#6cb6ff', // blue
  '#7fd1b9', // teal
  '#b39ddb', // purple
  '#f2a25c', // amber-orange
  '#e57fb0', // pink
  '#9ccc65', // green
  '#4dd0e1', // cyan
  '#ffb3c1', // rose
  '#c0a4f0', // lilac
  '#80cbc4', // mint
  '#a1c4fd', // periwinkle
  '#d7b899', // sand
  '#8fd6a0', // spring-green
  '#f0a6ca', // blossom
];

/** Stable FNV-1a hash of a public player id — the shared basis for any
 *  deterministic, team-neutral per-player pick (colour, portrait variant, …). */
export function hashId(id: string): number {
  let h = 2166136261;
  for (let i = 0; i < id.length; i++) {
    h ^= id.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

/** The identity colour (hex) for a player id. */
export function playerColor(id: string): string {
  return PALETTE[hashId(id) % PALETTE.length]!;
}
